import React from 'react'

const Brands = () => {
    return (
        <section class="brands">
        <div class="brand-img-ctr">
          <img src="media/brands/netflix.svg" />
        </div>
        <div class="brand-img-ctr">
          <img src="media/brands/reddit.svg" />
        </div>
        <div class="brand-img-ctr">
          <img src="media/brands/amazon.svg" />
        </div>
        <div class="brand-img-ctr">
          <img src="media/brands/discord.svg" />
        </div>
        <div class="brand-img-ctr">
          <img src="media/brands/spotify.svg" />
        </div>
      </section>
    )
}

export default Brands
